import React, {FunctionComponent, useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useHistory} from 'react-router-dom';

import {switchWorkspace} from '../../store/actions/workspaceActions';
import {IState} from '../../store/reducers';
import {ApiStatus, IWorkspace} from '../../models';
import {WorkspaceSelection} from './WorkspaceSelection';
import {WorkspaceSelectionWrapper} from './WorkspaceSelectionWrapper';
import {useCurrentUser} from "../../hooks/use-user-current-workspace";
import {sortWorkspaces} from './utils';

type WorkspaceSelectionContainerProps = {};

export const WorkspaceSelectionContainer: FunctionComponent<WorkspaceSelectionContainerProps> = ({}: WorkspaceSelectionContainerProps) => {
  const history = useHistory();
  const location = useLocation();
  const workspaces = useSelector((state: IState) => state.workspaces.workspaces);
  const workspacesLoading = useSelector((state: IState) => state.workspaces.loadingListStatus);
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const [switchingWorkspace, setSwitchingWorkspace] = useState<string | null>(null);

  const onSelectWorkspace = useCallback((workspace: IWorkspace) => {
    setSwitchingWorkspace(workspace.uid);
    if (currentUser?.current_workspace_uid !== workspace.uid) {
      dispatch(switchWorkspace(workspace.uid, {toaster: false}));
      history.replace({pathname: location.pathname, search: ''});
    } else {
      history.replace({pathname: location.pathname, search: ''});
      window.location.reload();
    }
  }, [currentUser, setSwitchingWorkspace]);

  return (
    <WorkspaceSelectionWrapper>
      <WorkspaceSelection
        workspaces={sortWorkspaces(workspaces)}
        workspacesLoading={workspacesLoading === ApiStatus.LOADING}
        switchingWorkspace={switchingWorkspace}
        currentUser={currentUser}
        onSelectWorkspace={onSelectWorkspace}
      />
    </WorkspaceSelectionWrapper>
  );
};
